import React, {useEffect, useState} from 'react';
import Typography from "@mui/material/Typography";
import {Box, Button, CircularProgress, Paper, TextField} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import IsError from "../common/IsError";
import CustomAlert from "../common/CustomAlert";
import {useCreateFeedbacksMutation} from "../../store/rtk-api/review/review";

const ReplyPage = () => {
    const navigate = useNavigate()
    const {state} = useLocation()
    const [isReply, setReply] = useState(false)
    const [message, setMessage] = useState('')
    const [createFeedback, {isLoading, isError, isSuccess}] = useCreateFeedbacksMutation()
    const [alertOpen, setAlertOpen] = useState(false)
    const handleReply = () => {
        if (isReply) {
            createFeedback({
                // @ts-ignore
                id: +state.id,
                body: {
                    text: message
                }
            })
        } else setReply(true)
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMessage(e.target.value)
    }

    useEffect(() => {
        if (isSuccess || isError) {
            setAlertOpen(true)
            setTimeout(() => {
                setAlertOpen(false)
                if (isSuccess) {
                    navigate(-1)
                }
            }, 2000)
        }
    }, [isSuccess, isError])

    // @ts-ignore
    let stateName = state.name
    // @ts-ignore
    let stateLastName = state.lastName
    // @ts-ignore
    let stateMiddleName = state.middleName
    // @ts-ignore
    let stateImg = state.image

    return (
        <Box sx={{display: "flex", flexDirection: "column", gap: "30px", p: "80px"}}>
            <IsError isError={isError}/>
            {isLoading && <CircularProgress/>}
            {isSuccess && alertOpen && <CustomAlert message={"Ответ успешно отправлен!"} status={"success"}/>}
            <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                <img style={{
                    borderRadius: "100px",
                    height: "80px",
                    width: "80px"
                }}
                     src={stateImg}

                />
                <div>

                    <Typography
                        sx={{fontSize: "20px"}}>{`${stateName} ${stateLastName} ${stateMiddleName}`}</Typography>
                    {/*<Typography sx={{fontSize: "15px", color: "gray"}}>Гастроэнолог</Typography>*/}
                    {/*<Typography sx={{fontSize: "15px", color: "gray"}}>Стаж 18 лет</Typography>*/}
                </div>
            </Box>
            <Box sx={{
                outline: "1px solid gray",
                maxWidth: "600px",
                p: "20px 60px 20px 30px",
                boxSizing: "border-box"
            }} component={Paper}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    mb: "20px"

                }}
                >
                    <div style={{
                        width: "35px",
                        height: "40px",
                        backgroundColor: "#5BA0CE",
                        color: "#fff",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>10
                    </div>
                    <div>
                        <Typography sx={{fontSize: "16px"}}>Комментарий от пользователя</Typography>
                        {/*// @ts-ignore*/}
                        <Typography sx={{fontSize: "13px", color: "gray"}}>{state.date}</Typography>
                    </div>
                </Box>
                {/*// @ts-ignore*/}
                <Typography sx={{fontSize: "15px", mb: "10px"}}>{state.comment}
                </Typography>
                {/*// @ts-ignore*/}
                <Typography sx={{fontSize: "14px", color: "gray"}}>Написал комментарий: {state.patient}</Typography>

            </Box>
            {isReply &&
                <TextField onChange={handleChange} value={message} sx={{maxWidth: "600px"}} multiline rows={4}/>}
            <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                <Button variant={"contained"} onClick={() => navigate(-1)}>Назад к списку</Button>
                <Button variant={"contained"} onClick={handleReply}>Ответить</Button>
            </Box>

        </Box>
    );
};

export default ReplyPage;